// src/utils/productLabels.ts
import { ProductStatus } from '@models/product';
import { ProductSaleType, ProductType } from '@apis/product';

/**
 * User-facing labels for product status
 */
export const PRODUCT_STATUS_LABELS: Record<ProductStatus, string> = {
  [ProductStatus.ACTIVE]: 'Active',
  [ProductStatus.OUT_OF_STOCK]: 'Out of Stock',
  [ProductStatus.DISCONTINUED]: 'Discontinued',
};

/**
 * User-facing labels for sale type (order type)
 */
export const PRODUCT_SALE_TYPE_LABELS: Record<ProductSaleType, string> = {
  [ProductSaleType.REAL_TIME]: 'Real-time',
  [ProductSaleType.RESERVATION]: 'Reservation',
};

/**
 * User-facing labels for product type
 */
export const PRODUCT_TYPE_LABELS: Record<ProductType, string> = {
  [ProductType.ESIM]: 'eSIM',
  [ProductType.PSIM_TOPUP]: 'USIM Top-up',
  [ProductType.RESERVE_ESIM]: 'SIM Pickup',
  [ProductType.ROUTER]: 'Router Rental',
};

/**
 * Generic helper to safely get label
 */
export const getLabel = <T extends string>(
  map: Record<T, string>,
  value: T | null | undefined,
): string => {
  if (!value) return '-';
  return map[value] ?? value;
};
